import { render, staticRenderFns } from "./summary-table.vue?vue&type=template&id=d601e100&scoped=true"
import script from "./summary-table.vue?vue&type=script&lang=js"
export * from "./summary-table.vue?vue&type=script&lang=js"
import style0 from "./summary-table.vue?vue&type=style&index=0&id=d601e100&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d601e100",
  null
  
)

export default component.exports